import moment from "moment";
import React, { useState } from "react";

import { useLocalStorage } from "../../hooks";
import { userState } from "../../redux/reducers/userReducer";

import profile_img from "../../assets/avatar_placeholder.png";

import { FunnelIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwDropzone, TwInputGroup, TwListBox, TwTextEditer, } from "../../components/tailwind";
import { cutString } from "../../helpers";
import { loadingState, setSectionLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { guestsFilter, profileDefaultAvatar } from "../../utils/constants";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { getUrlForBookings, getUrlForEvent } from "../../utils/confighelpers";
import TwDrawer from "../../components/tailwind/TwDrawer";
import { useToast } from "../../provider/ToastProvider";
import TwAutocomplete from "../../components/tailwind/TwAutocomplete";

export default function GuestEventBooking({
  title = "Guest List",
  bookingType = "teacherRecentBookings",
  customerId,
}) {
  const { t } = useTranslation();
  title = t("myGuests.guestList");
  const location = useLocation();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const userReduxState = useSelector(userState);
  const [bookingInfo, setBookingInfo] = React.useState();
  // const [anchorEl, setAnchorEl] = React.useState(null);
  const [listLoading, setListLoading] = React.useState(false);
  const { addToast, addSuccessToast, addErrorToast } = useToast();

  const [recentBookingsList, setRecentBookingsList] = React.useState([]);
  const [showViewMore, setShowViewMore] = React.useState(false);
  const [recentBookingsPageNumber, setRecentBookingsPageNumber] =
    React.useState(1);
  const [bookingFilter, setBookingFilter] = React.useState("all");
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState({
    title: "",
    message: "",
    promotionalImage: "",
  });
  const [formErrors, setFormErrors] = useState({
    title: "",
    message: "",
  });
  const [eventList, setEventList] = useState([]);
  const [searchEventId, setSearchEventId] = useState("");
  const [searchEventName, setSearchEventName] = useState("");

  const getRecentBookings = async (page = 1) => {
    setShowViewMore(false);
    setListLoading(true);

    let url = `${getUrlForBookings()}getMybookings?organizerId=${userReduxState.userData?._id}&teacherId=${userReduxState.userData?._id}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`;

    // if(searchEventId) {
    //   url += `&eventScheduleId=${searchEventId}`
    // }
    if(searchEventName) {
      url += `&eventName=${searchEventName}`
    }

    const manageClassesConfig = {
      method: "get",
      // url: `${getUrlForBookings()}getMybookings?teacherId=${userReduxState.userData?._id}${bookingType === "consumerBookings" ? `&studentId=${customerId}` : ``}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
      // url: `${getUrlForBookings()}getMybookings?organizerId=${userReduxState.userData?._id}&teacherId=${userReduxState.userData?._id}&page=${page}&limit=5&filterBy=${bookingFilter}&listFor=${userReduxState.businessType}`,
      url: url
    };
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.data.data.length) {
        setShowViewMore(true);
        if (recentBookingsPageNumber > 1) {
          setRecentBookingsList([
            ...recentBookingsList,
            ...manageClassesRequest.data.data.data,
          ]);
        } else {
          setRecentBookingsList(manageClassesRequest.data.data.data);
        }
      }
    }
    setListLoading(false);
  };

    const getListOfEvents = async () => {
      let mgClasses = [];
      const manageClassesConfig = {
        method: "get",
        url: `${getUrlForEvent()}list?listFor=${userReduxState.businessType}`,
      };
      dispatch(setSectionLoading(true));
      const manageClassesRequest = await axiosInstance(manageClassesConfig);
      dispatch(setSectionLoading(false));
      if (manageClassesRequest.status === 200) {
        if (manageClassesRequest.data.data.length) {
  
          for (const item of manageClassesRequest.data.data) {
            const isPresent = mgClasses.find((d) => d.label === item.eventName)
            if (!isPresent && item.allEventSchedules.length > 0) {
              mgClasses.push({
                label: item.eventName,
                id: item.allEventSchedules[0]._id,
                data: item
              });
            }
          }
          setEventList(mgClasses);
        }
      }
    };

  const toggleRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const allIds = recentBookingsList.map((row) => row._id);

  const isAllSelected =
    allIds.length > 0 && allIds.every((id) => selectedRows.includes(id));

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(allIds);
    }
  };

  const handleFilterChange = (event) => {
    const {
      target: { value },
    } = event;
    setRecentBookingsPageNumber(1);
    setBookingFilter(value);
    setRecentBookingsList([]);
  };

  const sendPromotionalEmail = () => {
    const newErrors = {};

    if (!drawerData.title) {
      newErrors.title = "Please enter title";
    }

    if (!drawerData.message) {
      newErrors.message = "Please enter message";
    }

    setFormErrors(newErrors);

    // stop submit if errors exist
    if (Object.keys(newErrors).length > 0) return;

    const selections = isAllSelected
      ? "all"
      : selectedRows.map((id) => {
          const booking = recentBookingsList.find((r) => r._id === id);
          return booking.consumerId;
        });
  };

  const handleSendMail = () => {
    const selections = selectedRows.map((id) => {
      const booking = recentBookingsList.find((r) => r._id === id);
      return booking.consumerEmail;
    });

    const uniqueSelections = [...new Set(selections)];

    if (!uniqueSelections.length) {
      return;
    }

    if (uniqueSelections.length > 100) {
      addErrorToast(t("myGuests.lengthExceedError"));
      return;
    }

    window.open(`mailto:${uniqueSelections.join(",")}`);
  };

  React.useEffect(() => {
    getListOfEvents();
  }, []);

  React.useEffect(() => {
    getRecentBookings(recentBookingsPageNumber);
  }, [recentBookingsPageNumber, bookingFilter, searchEventId]);

  return (
    <div
      className={`max-w-7xl bg-white rounded-lg border-2 border-bright-gray hover:border-primary ${bookingType === "teacherRecentBookings" ? "min-h-[500px] pb-10" : ""}`}
    >
      <div
        className={
          "flex flex-row justify-between items-center border-b-2 border-bright-gray p-5"
        }
      >
        <div className={"flex flex-col"} style={{ flex: 1 }}>
          <div className="flex justify-between">
            <h3 className={"text-black text-lg font-bold"}>{title}</h3>
            <div className="flex gap-2 justify-end items-center">
              {/* Add setOpenDrawer to open email drawer on click here */}
              <TwButton
                variant={"default"}
                disabled={!selectedRows.length}
                onClick={handleSendMail}
                className="whitespace-nowrap flex-shrink-0"
              >
                {t("myGuests.sendEmail")}
              </TwButton>
              <TwButton
                variant={"default"}
                onClick={() => {
                  setSelectedRows([]);
                  setRecentBookingsPageNumber(1);
                }}
              >
                <ArrowPathIcon
                  aria-hidden="true"
                  className="size-5 text-black forced-colors:text-[Highlight]"
                />
              </TwButton>
              {/* <TwListBox
                value={bookingFilter}
                options={guestsFilter}
                dropdownArrow={
                  <FunnelIcon
                    aria-hidden="true"
                    className="size-5 text-black forced-colors:text-[Highlight]"
                  />
                }
                onChange={(v) => {
                  setSelectedRows([]);
                  handleFilterChange({ target: { value: v.value } });
                }}
              /> */}
              <TwAutocomplete
                options={eventList}
                placeholder={t("myGuests.filterByEvent")}
                // defaultValue={searchVal}
                onChange={async (newValue) => {
                  if (newValue) {
                    setRecentBookingsPageNumber(1);
                    setRecentBookingsList([]);
                    setSearchEventId(newValue.id);
                    setSearchEventName(newValue.label);
                  } else {
                    setRecentBookingsPageNumber(1);
                    setSearchEventId("");
                    setSearchEventName("");
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto my-5 sm:m-5">
        <div className="inline-block min-w-full py-2 align-middle sm:px-1 overflow-x-auto">
          <div className="overflow-hidden [shadow] ring-0 ring-black/5 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
              <thead className="bg-form">
                <tr>
                  <th className="w-12 px-3 py-4 text-center">
                    <input
                      type="checkbox"
                      checked={isAllSelected}
                      onChange={toggleSelectAll}
                      className="h-4 w-4 cursor-pointer"
                    />
                  </th>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    {t("dashboard.customer")}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("inputFieldsTitle.email")}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {t("dashboard.activityBooked")}
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {listLoading ? (
                  <tr>
                    <td
                      colSpan={4}
                      className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center"
                    >
                      {t("inputFieldsTitle.loading")}
                    </td>
                  </tr>
                ) : recentBookingsList.length > 0 ? (
                  recentBookingsList.map((row, i) => (
                    <tr key={i}>
                      <td className="w-12 px-3 py-4 text-center">
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row._id)}
                          onChange={() => toggleRow(row._id)}
                          className="h-4 w-4 cursor-pointer"
                        />
                      </td>
                      <td className="whitespace-nowrap py-5 pt-6 pl-4 pr-3 text-sm font-bold text-gray-900 sm:pl-6 flex gap-2 items-center flex ">
                        <div className="flex justify-start items-center [min-w-4/5] w-full line-clamp-1">
                          <div className="flex-none">
                            {row?.consumer_detail?.profilePic ? (
                              <img
                                className="size-8 rounded-full mr-3"
                                src={
                                  row?.consumer_detail?.profilePic ??
                                  profileDefaultAvatar
                                }
                                alt={``}
                              />
                            ) : (
                              <img
                                className="size-8 rounded-full mr-3"
                                src={profile_img}
                                // src={profileDefaultAvatar}
                                alt={``}
                              />
                            )}
                          </div>
                          <div className="flex-1 min-w-0 line-clamp-1">
                            {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                            <div className=" line-clamp-1">
                              {row?.consumer_detail?.fullName}
                            </div>
                            <div className="text-primary line-clamp-1">
                              {row.consumer_detail?.countryCode
                                ? row.consumer_detail.countryCode +
                                  "_" +
                                  row.consumer_detail.phoneNumber
                                : "" + row?.consumer_detail?.username}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                        <div>{row.consumer_detail?.email}</div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-bold">
                        <div>
                          {row?.eventName ||
                            row?.event_detail?.eventName ||
                            row?.event_schedule_detail?.eventName ||
                            ""}
                          <p className="text-xs text-gray-400 font-normal text-wrap">
                            {row.event_schedule_detail &&
                            row.event_schedule_detail.eventDate
                              ? moment(
                                  row.event_schedule_detail.eventDate,
                                ).format("MMM D, hh:mm A")
                              : ""}
                          </p>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={4}
                      className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center"
                    >
                      {t("bookings.noBookingsYet")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showViewMore ? (
        <div className={"flex flex-row justify-center my-4"}>
          <TwButton
            variant={"default-box"}
            className="sm:min-w-32 truncate !text-primary"
            onClick={() => {
              setSelectedRows([]);
              setRecentBookingsPageNumber(recentBookingsPageNumber + 1);
            }}
          >
            {t("inputFieldsTitle.viewMore")}
          </TwButton>
        </div>
      ) : (
        ""
      )}

      {/* {Send Email Drawer} */}
      {openDrawer && (
        <TwDrawer
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          title={t("myGuests.promotionalEmail")}
          children={
            <div className="flex flex-col gap-2">
              <TwInputGroup
                label={t("myGuests.title")}
                value={drawerData.title}
                name={"title"}
                errors={formErrors}
                onChange={(e) =>
                  setDrawerData({ ...drawerData, title: e.target.value })
                }
              />
              <TwTextEditer
                label={t("myGuests.promotionalMessage")}
                value={drawerData.message}
                name={"message"}
                errors={formErrors}
                onChange={(value) =>
                  setDrawerData({ ...drawerData, message: value })
                }
              />
              <TwDropzone
                variant="all"
                label={t("myGuests.promotionalImage")}
                name={"promotionalImage"}
                // errors={formErrors}
                value={drawerData.promotionalImage}
                onChange={(image) => {
                  setDrawerData({ ...drawerData, promotionalImage: image });
                }}
              />
            </div>
          }
          footerChildren={
            <>
              <TwButton
                variant={"secondary-outline"}
                disabled={loadingReduxState.actionLoading}
                onClick={() => setOpenDrawer(false)}
              >
                {t("inputFieldsTitle.cancel")}
              </TwButton>

              <TwButton variant="secondary" onClick={sendPromotionalEmail}>
                {t("myGuests.sendEmail")}
              </TwButton>
            </>
          }
        />
      )}
    </div>
  );
}
